import { asMultiStyleConfig } from '../../../../utils/theme';
export var AttentionMessage = asMultiStyleConfig({
  parts: ['title', 'description', 'container'],
  baseStyle: {
    title: {
      fontWeight: 'semibold'
    },
    container: {
      backgroundColor: 'white'
    },
    description: {
      fontSize: {
        base: 'sm',
        md: 'md'
      }
    }
  }
});